<template>
  <div class="c-recommend">
    <div class="c-re-head c-title">
      <div class="c-hd-title">{{  value.COLUMNNAME  }}</div>
      <router-link class="c-more" :to="'/recommend/' + value.ID">
        More
        <i class="icon iconfont icon-gengduo2"></i>
      </router-link>
    </div>
    <div class="c-re-body">
      <ul class="c-re-plist">
        <li class="c-re-item" v-for="(item, index) of productData" :key="item.Id" v-if="index < 12">
          <router-link :to="$fun.getProductUrl(item.Id, item.ProductType)">
            <div class="c-r-simg">
              <!-- <div class="img-tag1">{{item.SOURCEOPENTYPE ==="01" ? '借阅' : '畅读' }}</div> -->
              <template v-if="item.Cover"><img :src="item.Cover"/></template>
              <template v-else><img src="/static/img/np-img.png" /></template>
              <!-- <span class="img-tag">{{ item.ProductTypeText }}</span> -->
            </div>
            <div class="c-r-bkname">{{  item.Name  }}</div>
            <div class="c-r-author">{{  item.Author  }}</div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  name: "Recommend",
  data: function () {
    return {
      productData: []
    };
  },
  mounted: function () {
    this.$bti.GetBelongToColumnPage({page: 1,rows: 12, wheres: { ColumnId: this.value.ID, OrgId: this.$fun.getMember().orgId, IsSingle: true }}).then((res) => {
      if (res.code != 1) {
          return;
      }
      this.productData = res.data.rows;
    });
  },
};
</script>

<style lang="css" scoped>
.c-re-body {
  padding: 20px 0px;
}

.c-re-plist {
  *zoom: 1;
}

.c-re-plist:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.c-re-item {
  float: left;
  display: inline;
  width: 180px;
  height: 270px;
  background: #fff;
  padding: 26px 25px 0px 25px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  margin-left: 23px;
  margin-bottom: 23px;
}

.c-re-item:nth-child(1),
.c-re-item:nth-child(7) {
  margin-left: 0px;
}

.c-re-item a {
  display: block;
}

.c-re-item .c-r-simg {
  position: relative;
  width: 130px;
  height: 172px;
}

.c-re-item .c-r-simg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.c-re-item .c-r-bkname {
  width: 100%;
  height: 18px;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  color: #252525;
  margin-top: 12px;
  text-align: center;
}

.c-re-item .c-r-author {
  text-align: center;
  color: #323232;
  font-size: 12px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.c-re-body .c-r-simg{
  position: relative;
}
.c-re-body .c-r-simg .img-tag1{
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,#409EFF,#409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Recommend.vue